/* ═══════════════════════════════════════════════════════════════════
   Palladium PageBuilder — entrance animations runtime (storefront)

   Pairs with pb-animations.css. Elements carrying `.pb-anim` +
   `.pb-anim--<effect>` (written by the editor's "Animation d'entrée"
   panel) animate in when they enter the viewport.

   Contract:
   - We gate hiding on `html.pb-anim-ready`: no JS / no IO support /
     reduced-motion → class absent → content fully visible.
   - `.pb-anim-repeat` elements replay on every viewport entry;
     everything else animates once and is unobserved.
   - `.pb-anim-group` on an ancestor = a sequence: its `.pb-anim`
     descendants all start together when the GROUP is well inside the
     viewport (its top past 80% of the screen), their delays then
     setting the order. Without it each element starts on its own entry,
     so a tall block played its last steps before they were on screen.
   - Works on static-SSR pages AND under Blazor circuits: a
     MutationObserver picks up nodes the circuit patches in later.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
    'use strict';

    if (!('IntersectionObserver' in window) || !document.body) return;
    try {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    } catch (e) { /* matchMedia missing → animate */ }

    document.documentElement.classList.add('pb-anim-ready');

    var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
            var el = entries[i].target;
            if (entries[i].isIntersecting) {
                el.classList.add('pb-anim-in');
                if (!el.classList.contains('pb-anim-repeat')) io.unobserve(el);
            } else if (el.classList.contains('pb-anim-repeat')) {
                // Left the viewport → re-arm for the next entry.
                el.classList.remove('pb-anim-in');
            }
        }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    // Sequences: the group is observed instead of its members (once).
    var groupIo = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            var g = entries[i].target;
            groupIo.unobserve(g);
            var list = g.querySelectorAll('.pb-anim');
            for (var j = 0; j < list.length; j++) list[j].classList.add('pb-anim-in');
        }
    }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });

    var seen = new WeakSet();
    var groups = new WeakSet();
    function observe(el) {
        if (seen.has(el)) return;
        seen.add(el);
        var group = el.parentElement && el.parentElement.closest('.pb-anim-group');
        if (group) {
            if (!groups.has(group)) { groups.add(group); groupIo.observe(group); }
            return;
        }
        io.observe(el);
    }
    function scan(scope) {
        if (!scope || !scope.querySelectorAll) return;
        if (scope.classList && scope.classList.contains('pb-anim')) observe(scope);
        var list = scope.querySelectorAll('.pb-anim');
        for (var i = 0; i < list.length; i++) observe(list[i]);
    }

    scan(document);

    // Blazor (circuit patches, enhanced nav) and widgets add nodes after
    // load — watch for them. childList-only subtree observer: cheap, and
    // class flips we make ourselves don't retrigger it.
    var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
            var added = muts[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
                if (added[j].nodeType === 1) scan(added[j]);
            }
        }
    });
    mo.observe(document.body, { childList: true, subtree: true });
})();
